import { render } from "./Remove-anchor-popup.vue?vue&type=template&id=48aeb4ec&scoped=true"
import script from "./Remove-anchor-popup.vue?vue&type=script&lang=js"
export * from "./Remove-anchor-popup.vue?vue&type=script&lang=js"

import "./Remove-anchor-popup.vue?vue&type=style&index=0&id=48aeb4ec&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48aeb4ec"]])

export default __exports__